import React from 'react'
import TextEditorDraft from './TextEditorDraft'
import { withFormsy } from 'formsy-react'
import _ from '@lodash'

function TextEditorDraftFormsy(props) {
  const importedProps = _.pick(props, [
    'classes',
    'id',
    'label',
    'name',
    'maxLength',
    'textStatus',
    'controls',
    'required',
    'isControlsInline',
    'isDoNotTranslateEnable',
    'isNoRichFormat',
    'linkEnabled',
    'tabIndex',
    'extraMsg',
    'onSelectTemplate',
    'templateId',
    'templates',
    'isDisabled',
  ])

  const value = props.value

  function changeValue(value) {
    props.setValue(value)
    if (props.onChange) {
      props.onChange(value)
    }
  }

  return (
    <TextEditorDraft {...importedProps} value={value} onChange={changeValue} />
  )
}

export default React.memo(withFormsy(TextEditorDraftFormsy))
